/* Lovy Studios — cart-drawer tweaks, zie snippets/lovy-cart-tweaks.liquid */
(function () {
    var SEL = '#essential-cart-drawer-portal [data-essential-cart-element="cart-drawer-checkout-button-text"]';
    var PRICE = '[data-essential-cart-element="cart-drawer-checkout-button-price"]';
    var DESIRED = 'Secure checkout';
    var LOCK = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-2px;margin-left:7px;display:inline-block"><rect x="3" y="11" width="18" height="11" rx="0"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>';
    function fix() {
      // Re-apply whenever the app reset the button (price span back, or text changed).
      var nodes = document.querySelectorAll(SEL);
      for (var i = 0; i < nodes.length; i++) {
        var t = nodes[i];
        if (t.querySelector(PRICE) || t.textContent.trim() !== DESIRED) {
          t.innerHTML = DESIRED + LOCK;
        }
      }
    }
    // Lovy 5 sep 2026: alleen reageren op mutaties ín de Essential-lade (of het
    // toevoegen van de lade zelf). Voorheen draaide fix() bij élke DOM-mutatie op
    // de hele pagina (Clarity, morph, popup-animatie), incl. characterData.
    var PORTAL = 'essential-cart-drawer-portal';
    function raaktLade(m) {
      var t = m.target;
      if (t && t.closest && t.closest('#' + PORTAL)) return true;
      var a = m.addedNodes;
      for (var i = 0; i < a.length; i++) {
        var n = a[i];
        if (n.nodeType === 1 && (n.id === PORTAL || (n.querySelector && n.querySelector('#' + PORTAL)))) return true;
      }
      return false;
    }
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) { if (raaktLade(muts[i])) { fix(); return; } }
    });
    obs.observe(document.body || document.documentElement, { childList: true, subtree: true });
    if (document.readyState !== 'loading') fix();
    else document.addEventListener('DOMContentLoaded', fix);
  })();
